/**
 * 業務・業務ロジック（F3）の oRPC contract。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務ロジック・業務ルール・業務詳細の読取 procedure の入出力を oRPC contract として定義する。
 * @graph-connects none
 */
import { BusinessDetailInputSchema, BusinessDetailPairSchema } from '../elements/index.js';
import { GetBusinessRulesInputSchema, GetBusinessRulesOutputSchema, GetRuleInputSchema, GetRuleOutputSchema, } from '../spec-graph-rule-flow.js';
import { base } from './common.js';
/**
 * 業務・業務ロジックの読取 procedure（`specGraph` に載る）。
 * @graph-connects none
 */
export const businessLogicContract = {
    /*
     * 業務・業務ロジック（API 仕様 §4.2）。案件は `pjNumber`（number）で受け、面は持たない
     * （変更前はマスターそのもの）。
     */
    getBusinessRules: base.input(GetBusinessRulesInputSchema).output(GetBusinessRulesOutputSchema),
    /*
     * 業務ルール 1 件（業務ルールの画面）。master と案件適用後の姿を 1 つの応答で返す。
     */
    getRule: base.input(GetRuleInputSchema).output(GetRuleOutputSchema),
    /*
     * 業務そのもの。案件は番号だけを受け、面（`before` / `after`）は持たない。**出力が両方の姿を
     * 返す**ので、面で分けると画面が同じ業務を 2 回引くことになる。
     */
    getBusinessDetail: base.input(BusinessDetailInputSchema).output(BusinessDetailPairSchema),
};
//# sourceMappingURL=business-logic.js.map